export default function applyCameraData(state, { data, filename }) {
  return Object.assign({}, state, {
    cameraModels: data.cameras,
    cameraFilters: data.filters,
    cameraDataFilename: filename,
    doorControllerModels: data.doorControllers,
    expansionControllerModels: data.expansionControllers
  })
}



// WEBPACK FOOTER //
// ./src/reducers/applyCameraData.js